import {Validators} from '@angular/forms';

import {Helper, SelectControl} from '../../../app/shared/classes';
import {ComponentTypesEnum} from '../../../app/shared/enums';

import {RiskClassificationBandsEnum} from '@spa/api';

export const ComplianceAMLRiskSelector = 'complianceAMLRisk';

export const ComplianceRiskControl = (): SelectControl => {
    return new SelectControl({
        name: ComplianceAMLRiskSelector,
        value: null,
        placeholder: 'Compliance AML risk',
        validators: [Validators.required],
        componentType: ComponentTypesEnum.Select,
        options: [
            {
                label: Helper.textsHelper().getRiskClassificationBandName(RiskClassificationBandsEnum.Low),
                value: RiskClassificationBandsEnum.Low
            },
            {
                label: Helper.textsHelper().getRiskClassificationBandName(RiskClassificationBandsEnum.Medium),
                value: RiskClassificationBandsEnum.Medium
            },
            {
                label: Helper.textsHelper().getRiskClassificationBandName(RiskClassificationBandsEnum.High),
                value: RiskClassificationBandsEnum.High
            }
        ],
        floatingLabelNever: true
    });
};
